const customSelectors = {
    notifyMeBtn: document.querySelectorAll('.notify-me .notify-me-btn'),
    notifyModal: document.querySelector('#PopupModal-notifyme'),
    notifyMeForm: document.querySelector('#PopupModal-notifyme form'),
    customSliderSelector: document.querySelector('.feature-slider')
};

class customJS {
    constructor() {
        if(customSelectors.notifyMeBtn.length > 0) this.notifyMe();
        if(customSelectors.customSliderSelector) this.manageFeaturedSlider();
        let collectionURL = window.location.pathname;
        if (collectionURL == '/collections/all-products') {
            window.location.href = "/";
        }
    }

    notifyMe(){
        customSelectors.notifyMeBtn.forEach((button)=>{
            button.addEventListener('click', (event)=>{
                event.preventDefault();
                let target = event.currentTarget;
                let form = target.closest('product-form');
                let selectedVariantID = form.querySelector('input[name="id"]').value;
                let productTitle = target.dataset.title;
                let productID = target.dataset.id;
                let qunatity = form.querySelector('input[name="quantity"]').value || 1;
                let variantsData = JSON.parse(form.querySelector('[data-variantjson]').innerHTML);
                let selectedVariant = variantsData.find(item => item.id == selectedVariantID);
                this.selectedVariant = selectedVariant;
                let scriptEle = customSelectors.notifyModal.querySelector('[data-bodyJSON]');
                scriptEle.innerHTML = JSON.stringify({
                        "device": "web",
                        "product_id": productID,
                        "product_name": productTitle,
                        "shopify_domain": `${Shopify.shop}`,
                        "variant_id": selectedVariantID,
                        "variant_name": selectedVariant ? selectedVariant.title : "",
                        "variant_qty": qunatity,
                        "variant_sku": selectedVariant ? selectedVariant.sku : "",
                });
                openModal(customSelectors.notifyModal, target);
            })
        });

        if(customSelectors.notifyMeForm){
            customSelectors.notifyMeForm.addEventListener('submit', (event)=>{
                event.preventDefault();
                let currentTarget = event.currentTarget;
                let submitBtn = currentTarget.querySelector('[type="submit"]');
                let emailValue = currentTarget.querySelector('[name="email"]').value;
                let validate = Utility.validateEmail(emailValue);
                if(validate == null) return;
                console.log(this.selectedVariant, 'selected variant');
                this.sendData(emailValue, this.selectedVariant.id, currentTarget)
                // let bodyJSON = currentTarget.querySelector('script[data-bodyJSON]') || null;
                // let bodyHTML = (bodyJSON) ? bodyJSON.innerHTML.trim() : null;
                // if(bodyHTML && bodyHTML.length > 0){
                //     let bodyJSON = JSON.parse(bodyHTML);
                //     bodyJSON.email = emailValue;

                //     const body = JSON.stringify(bodyJSON);
                //     submitBtn.classList.add('loading');
                //     submitBtn.disabled = true;

                //     fetch('https://restock-master.hulkapps.com/restock_notifier/frontend/add_notifier', { ...fetchConfig(), ...{ body }})
                //     .then((response) => {
                //         return response.json();
                //     })
                //     .then((response) => {
                //         submitBtn.classList.remove('loading');
                //         submitBtn.disabled = false;
                //         let statusMsg = response?.status_message?.toLowerCase();
                //         if(statusMsg?.indexOf('something went wrong') > -1){
                //             currentTarget.querySelector('.response-msg').classList.add('error');
                //             Utility.manageResponseText(currentTarget.querySelector('.response-msg'));
                //         }else{
                //             currentTarget.querySelector('.response-msg').classList.add('success');
                //             currentTarget.querySelector(".form_content").classList.add("d-none");
                //             customSelectors.notifyModal.querySelector("#close-modal").classList.add("d-none");
                //             Utility.manageResponseText(currentTarget.querySelector('.response-msg'));
                //             setTimeout(() => {
                //                 customSelectors.notifyModal.hide();
                //                 customSelectors.notifyModal.querySelector("#close-modal").classList.remove("d-none");
                //                 currentTarget.querySelector(".form_content").classList.remove("d-none");
                //             }, 5000);
                //         }
                //     }).catch((error) => {
                //         console.log(error);
                //         submitBtn.disabled = false;
                //         submitBtn.classList.remove('loading');
                //     });
                // }
            });
        }
    }

  
    sendData(emailValue, variantId, currentTarget) {
      let attributes = {
        ...(emailValue !== '' && {"email":`${emailValue}`})
      }

      const payload = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                  "type": "profile",
                  "attributes": {
                    "email": emailValue
                  } 
              }
            },
            "channels": ["EMAIL"],
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": `$shopify:::$default:::${variantId}`
              }
            }
          }
        }
      }
  
      var requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "revision":"2024-05-15"
        },
        body: JSON.stringify(payload),
      };
    
      // this.popupSubmit.classList.add('submitting')
      
      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=VHppZt`,requestOptions)
        .then(result => {
          console.log(result, 'result')
          let results = result.status === 202
          if(results) {
            currentTarget.querySelector('.form_content').classList.add('d-none');
            currentTarget.querySelector('.response-msg').style.display='block';
            currentTarget.querySelector('.response-msg').classList.add('success');
            currentTarget.closest('.modal-content').querySelector('.confetti-top').classList.remove('d-none');
          }

        })
        .catch(error => console.log('error', error));
  
    }



manageFeaturedSlider() {
    let w = window.innerWidth;
    if (w < 767) {
      const sliderEl = document.querySelector(".feature-slider");
      if (!sliderEl || sliderEl.dataset.initialized) return;

      const initSlider = () => {
        if (sliderEl.dataset.initialized) return;
        sliderEl.dataset.initialized = "true";
        new Swiper(".feature-slider", {
          slidesPerView: 1,
          spaceBetween: 0,
          slidesPerGroupSkip: 1,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: ".feature-button-next",
            prevEl: ".feature-button-prev",
          },
          pagination: {
            el: ".feature-pagination",
            clickable: true,
          },
        });
      };

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              initSlider();
              obs.disconnect();
            }
          });
        },
        { threshold: 0.1 }
      );

      observer.observe(sliderEl);
    }
  }
}

typeof customJS !== "undefined" && new customJS();
